/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component } from '@angular/core';
import { MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoggerService } from '../../modules/shared/services/logger.service';
import { MatToolbar } from '@angular/material/toolbar';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { LayoutDirective, LayoutAlignDirective } from '@ngbracket/ngx-layout/flex';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';

export interface GsptDialogResult {
    distance: number;
    direction: 'up' | 'down';
}
@Component({
    selector: 'dash-gis-gspt-dialog',
    templateUrl: './gspt-dialog.component.html',
    styleUrls: ['./gspt-dialog.component.scss'],
    imports: [
        MatToolbar,
        CdkScrollable,
        MatDialogContent,
        LayoutDirective,
        LayoutAlignDirective,
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatHint,
        MatRadioGroup,
        MatRadioButton,
        MatDialogActions,
        MatButton,
    ],
})
export class GsptDialogComponent {
    public gsptForm: UntypedFormGroup;

    constructor(private logger: LoggerService, private dialogRef: MatDialogRef<GsptDialogComponent, GsptDialogResult>) {
        // build form
        this.gsptForm = new UntypedFormGroup({
            distance: new UntypedFormControl(''),
            direction: new UntypedFormControl('up', Validators.required),
        });
    }

    public doTrace() {
        if (!this.gsptForm.value['direction']) {
            return false;
        }
        return this.dialogRef.close(this.gsptForm.value as GsptDialogResult);
    }

    public cancel() {
        this.dialogRef.close(null);
    }
}
